import { render, staticRenderFns } from "./AddPickupAddressModal.vue?vue&type=template&id=6ebe4bd0"
import script from "./AddPickupAddressModal.vue?vue&type=script&lang=ts"
export * from "./AddPickupAddressModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ebe4bd0')) {
      api.createRecord('6ebe4bd0', component.options)
    } else {
      api.reload('6ebe4bd0', component.options)
    }
    module.hot.accept("./AddPickupAddressModal.vue?vue&type=template&id=6ebe4bd0", function () {
      api.rerender('6ebe4bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/AddPickupAddressModal.vue"
export default component.exports